import { render, staticRenderFns } from "./TagsTabela.vue?vue&type=template&id=18f397b0"
import script from "./TagsTabela.vue?vue&type=script&lang=js"
export * from "./TagsTabela.vue?vue&type=script&lang=js"
import style0 from "./TagsTabela.vue?vue&type=style&index=0&id=18f397b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports